import { useEffect, useState } from "react";
import { navLinks } from "../../../mocks/communityData";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-display text-lg text-white">
            瓜
          </span>
          <span className="font-display text-xl text-foreground-900">
            吃瓜<span className="text-primary-500">同好会</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.key}
              href={item.anchor}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-600 transition hover:bg-background-100 hover:text-primary-500 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#join"
            className="rounded-full bg-primary-500 px-5 py-2 text-sm font-bold text-white transition hover:bg-primary-600 whitespace-nowrap"
          >
            立即加入 <i className="ri-arrow-right-line ml-1 align-middle" />
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          aria-label="打开导航菜单"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 transition hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} />
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="mx-4 mb-4 flex flex-col rounded-2xl border border-background-200 bg-background-50 p-2 shadow-sm md:hidden">
          {navLinks.map((item) => (
            <a
              key={item.key}
              href={item.anchor}
              onClick={() => setOpen(false)}
              className="rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-500"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-2 rounded-xl bg-primary-500 px-4 py-3 text-center text-sm font-bold text-white whitespace-nowrap"
          >
            立即加入
          </a>
        </nav>
      )}
    </header>
  );
}